import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'
import { telemetry } from './telemetry'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minuto
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

function getQueryErrorPath(queryKey: unknown): string {
  if (Array.isArray(queryKey) && queryKey.length > 0 && typeof queryKey[0] === 'string') {
    return `query:${queryKey[0]}`
  }
  return 'query:unknown'
}

queryClient.getQueryCache().subscribe((event) => {
  if (event.type === 'updated') {
    const q = event.query
    if (q.state.status === 'error' && q.state.error) {
      const err = q.state.error
      if (!(err instanceof ApiError)) {
        telemetry.reportApiError({
          path: getQueryErrorPath(q.queryKey),
          method: 'GET',
          status: 0,
        })
      }
    }
  }
})

queryClient.getMutationCache().subscribe((event) => {
  if (event.type === 'updated') {
    const m = event.mutation
    if (m.state.status === 'error' && m.state.error) {
      const err = m.state.error
      if (!(err instanceof ApiError)) {
        telemetry.reportApiError({
          path: 'mutation',
          method: 'POST',
          status: 0,
        })
      }
    }
  }
})
